var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgclosepiano(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 53,
    viewBox: "0 0 28 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 52.5,
    width: 52.5,
    height: 27.5,
    transform: "rotate(-90 0 52.5)",
    fill: "#004B5A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.56 27.3521C21.54 26.9676 21.3859 26.6021 21.1245 26.3186L9.18018 13.4206C9.03177 13.2611 8.8533 13.1323 8.65496 13.0416C8.45661 12.9509 8.24228 12.9 8.0242 12.8918C7.80611 12.8836 7.58855 12.9183 7.38394 12.994C7.17932 13.0696 6.99166 13.1847 6.83167 13.3327C6.67167 13.4806 6.54248 13.6585 6.45146 13.8562C6.36045 14.0539 6.30939 14.2676 6.30122 14.485C6.29304 14.7024 6.3279 14.9192 6.4038 15.1232C6.47971 15.3271 6.59517 15.5142 6.7436 15.6736L17.6407 27.4451L6.7436 39.2167C6.59517 39.3761 6.47971 39.5632 6.4038 39.7671C6.3279 39.9711 6.29304 40.1879 6.30122 40.4053C6.30939 40.6227 6.36045 40.8363 6.45146 41.034C6.54248 41.2318 6.67167 41.4097 6.83167 41.5576C6.99166 41.7056 7.17932 41.8206 7.38394 41.8963C7.58855 41.9719 7.80611 42.0067 8.0242 41.9985C8.24228 41.9903 8.45661 41.9394 8.65496 41.8487C8.8533 41.7579 9.03177 41.6292 9.18018 41.4697L21.1245 28.5716C21.2756 28.408 21.3921 28.2157 21.4669 28.0061C21.5418 27.7966 21.5734 27.5741 21.56 27.3521Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgclosepiano);
export default __webpack_public_path__ + "static/media/svgclosepiano.580cd8fb8b0ffed88271f0f977e0dd46.svg";
export { ForwardRef as ReactComponent };